import React from 'react'
import 'antd/lib/switch/style/index.css'
import {
	Row, Col, Tooltip
}from 'antd'
import '../style.css'
import moment from "moment"
import SignedIcon from "../../../../../public/signedIcon.png"
import AnswerFiles from '../../AppealFiles/AnswerFiles'
import i18n from './localization'

const AppealResult  = (props) => {
	const {
		appealResult, answerFiles, isRu, showSignerInfo, downloadMethod
	} = props

	return (
        <>
			<Row
				className="result-appeal"
				justify="center"
			>
				<Col className="header-result-appeal">
					<span>
						{ i18n.ReviewResult[isRu] }
						{ appealResult.signerInfo && showSignerInfo &&
							<Tooltip 
								title={i18n.signer[isRu].format(appealResult.signerInfo)}
								overlayInnerStyle={{ whiteSpace: 'pre-line' }}
								className="signed_icon"	
							>
								<img src={SignedIcon} className="signed_icon_for_message"/>
							</Tooltip>
						}
					</span>
					<span>
						{ appealResult?.caseNumber
							? `${ i18n.CaseNumber[isRu] } №${ appealResult.caseNumber }`
							: null }
					</span>
				</Col>
				<Col className="body-result-appeal">
					{ `${ appealResult.status && appealResult.status.code == "11"
                                          ? `${ appealResult.status.name }:\n${ appealResult.reviewResult }`
                                          : `\t${ appealResult.reviewResult }` }`.replace(/\n/g, `\n\t`) }
				</Col>
				<Col className="files-body-info-appeal">
					<AnswerFiles
						isRu={ isRu }
                        answerFiles = {answerFiles}
                        downloadMethod={downloadMethod}
						showSignerInfo={ showSignerInfo}
					/>
				</Col>
			</Row>

			{ appealResult && appealResult.endSignDate && appealResult.endSignerInfo && <Row className="footer-info-appeal">
				<Col span={ 12 }>
					<span>
						{ moment(appealResult.endSignDate).format("DD.MM.YYYY") }
					</span>
				</Col>
				<Col span={ 12 }>
					<span>
						{ appealResult.endSignerInfo }
					</span>
				</Col>
			</Row> }
		</>

    )
}

export default AppealResult
